import React from "react"

const ShortDescription = ({ shortDescription }: Props) => {
	if (!shortDescription) return null

	return (
		<>
			<div
				style={{ color: "#505e5f", fontSize: 14 }}
				dangerouslySetInnerHTML={{
					__html: shortDescription,
				}}
			/>
			<div
				style={{
					marginTop: "0.25rem",
					marginBottom: "0.75rem",
				}}
			>
				<a
					href="#description"
					style={{
						textDecoration: "underline",
						fontSize: 14,
						color: "#274041",
						marginTop: "2rem",
					}}
				>
					Weitere Produktinformationen
				</a>
			</div>
		</>
	)
}

interface Props {
	shortDescription: string
}

export default ShortDescription
